// usage: <core-high-low-indicator high-or-low="High||Low" low-msg="..." high-message="..." />
export const HighLowIndicatorComponent = {
  bindings: {
    highOrLow: '@',
    highMessage: '@',
    lowMessage: '@'
  },
  template: `<i data-placement="top" class="fa fa-lg" data-trigger="hover"
    data-title="{{$ctrl.highOrLow === 'High' ? $ctrl.highMessage : $ctrl.lowMessage}}" bs-tooltip
    ng-class="{
      'fa-arrow-circle-up': $ctrl.highOrLow === 'High',
      'fa-arrow-circle-down': $ctrl.highOrLow === 'Low'
    }"><i>`
};
